import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Home, Users, Grid, UserCheck, HelpCircle, Menu, LogOut } from "react-feather";
// import logo from "../component/img/ignlogo.png";
import Swal from "sweetalert2";
import { baseurl } from "../../../Baseurl";

const SuperSideBar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [adminData, setAdminData] = useState(null);
  const [modules, setModules] = useState([]);

  useEffect(() => {
    const adminId = localStorage.getItem("admin_id");
    if (adminId) {
      fetch(`${baseurl}/FetchAdminDataById/${adminId}`)
        .then((res) => res.json())
        .then((data) => {
          setAdminData(data.admin);
          setModules(data.admin.modules.map((mod) => JSON.parse(mod))); // Parse module JSON strings
        })
        .catch((error) => console.error("Error fetching admin data:", error));
    }
  }, []);

  const isActive = (path) => location.pathname === path;

  const handleLogout = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You are about to log out.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, log out",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        localStorage.removeItem("admin_id");
        localStorage.removeItem("admin_email");
        navigate("/admin/login");
      }
    });
  };

  return (
    <div className="sidebar superwidth2" style={{width : '200px'  }}>
      <div className="sidebar-header">
        <div className="text-dark d-flex align-items-center">
          {/* <img src={logo} className="img-fluid logoadmin" alt="Logo" />&nbsp; */}
          <span className="kal11">Bosplan Super Admin</span>
        </div>
      </div>
      <ul className="sidebar-menu">
         
          <li className={isActive("/admin/dashboard") ? "active" : ""}>
            <Link to="/admin/dashboard" className="kp">
              <Home className="ic" />
              <span>Dashboard</span>
            </Link>
          </li>
        
 
            <div className="liname my-2">Project Management</div>
            <li className={isActive("/superadmin/all-organization") ? "active" : ""}>
              <Link to="/superadmin/all-organization" className="kp">
                <HelpCircle className="ic" />
                <span>Organization</span>
              </Link>
            </li>


            {/* <li className={isActive("/all-assignee") ? "active" : ""}>
              <Link to="/all-assignee" className="kp">
                <HelpCircle className="ic" />
                <span>All Assignee</span>
              </Link>
            </li> */}

            {/* <li className={isActive("/admin/all-category") ? "active" : ""}>
              <Link to="/admin/all-category" className="kp">
                <HelpCircle className="ic" />
                <span>All Category</span>
              </Link>
            </li>

            <li className={isActive("/admin/all-trash-category") ? "active" : ""}>
              <Link to="/admin/all-trash-category" className="kp">
                <HelpCircle className="ic" />
                <span>All Trash Category</span>
              </Link>
            </li> */}

 
   

       
 


        <div className="liname my-2">Logout</div>
        <li>
          <Link className="kp" onClick={handleLogout}>
            <LogOut className="ic" />
            <span>Logout</span>
          </Link>
        </li>
      </ul>
    </div>
  );
};

export default SuperSideBar;
